
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  CreateDocumentAPI,
  GetDocumentsForApplicant,
} from "../adminApi";
import { CreateDocumentDto } from "../models";

export const GetDocumentsForApplicantThunk = createAsyncThunk(
  "GetDocumentsForApplicant",
  async (payload: number) => {
    let response: any;
    await GetDocumentsForApplicant(payload)
      .then((data) => {
        response = data;
      })
      .catch((error) => {
        response = error.response.data;
      });
    return response;
  }
);

export const CreateDocumentAPIThunk = createAsyncThunk(
  "CreateDocumentAPI",
  async (payload: CreateDocumentDto) => {
    let response: any;
    await CreateDocumentAPI(payload)
      .then((data) => {
        response = data;
      })
      .catch((error) => {
        response = error.response.data;
      });
    return response;
  }
);